import axios from "axios";
const BASE_URL = process.env.REACT_APP_DOWNLOAD_LOG_URL;


const axiosCilentLoggig = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
});

axiosCilentLoggig.defaults.timeout = 60000;

axiosCilentLoggig.interceptors.request.use(async (request) => {
  return {
    ...request,
  };
});

axiosCilentLoggig.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    throw err;
  }
);

export default axiosCilentLoggig;
